import React from 'react';
import { Badge } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';

function PillsDynamic({
    pillList = [],
    className = '',
    handleEdit = null,
    customIcon: CustomIcon = X, // Allow custom icon, default to `X`
    emptyState = null, // Custom empty state
    ...rest
}) {
    return (
        pillList && pillList.length > 0 ? (
            <div className="pill-display">
                {pillList.map((thisPill, index) => (
                    <Badge key={index} className={className} {...rest}>
                        {thisPill}
                        {handleEdit && (
                            <CustomIcon
                                className="svg-16"
                                onClick={() => handleEdit(thisPill)}
                                role="button"
                                aria-label={`Edit ${thisPill}`}
                            />
                        )}
                    </Badge>
                ))}
            </div>
        ) : (
            emptyState || null // Render empty state if provided, otherwise render nothing
        )
    );
}

export default PillsDynamic